var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pageImages } from '@/pages/images';
import { StepLayout } from './step-layout.component';
import { ChevronIcon } from './chevron-icon.component';
import { InformationToggle } from './information-toggle.component';
import { Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { AgeSelect } from 'hx-ui';
import { useFormContext } from 'react-hook-form';
import { palette } from '@/theme/palette';
import { useSendButtonClick } from '@/hooks/use-send-button-click.hook';
export function AgeSelectComponent() {
    var theme = useTheme();
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var getValues = useFormContext().getValues;
    var handleOpen = function () { return setIsOpen(true); };
    var handleClose = function () { return setIsOpen(false); };
    var birthYearValue = getValues('birth-year');
    var handleSendButtonClick = useSendButtonClick().handleSendButtonClick;
    return (_jsx(StepLayout, { image: pageImages.norcSelectBirthYear, progress: {
            step: 2,
            phase: 0,
        }, heading: _jsx(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl leading-10 mb-4" }, { children: "Select your birth year." })), content: _jsxs("div", __assign({ className: "flex flex-col items-center gap-16" }, { children: [_jsx("div", __assign({ className: "py-5 flex flex-col gap-3" }, { children: _jsx(AgeSelect, { selectProps: {
                            variant: 'standard',
                            className: 'min-w-[15em]',
                            showEighteenPlusYearsOnly: true,
                            sx: {
                                color: palette.text.dark,
                                fontWeight: 700,
                                fontSize: !!birthYearValue ? '32px' : 'inherit',
                                '&.MuiInput-underline:before': {
                                    borderColor: palette.primary.main,
                                },
                                '& .MuiInputBase-root': {
                                    backgroundColor: 'transparent !important',
                                    '&.Mui-focused': {
                                        backgroundColor: 'transparent',
                                    },
                                },
                                '& .MuiSelect-select': {
                                    backgroundColor: 'transparent !important',
                                },
                            },
                            customIcon: function (props) { return (_jsx(ChevronIcon, __assign({}, props, { isOpen: isOpen }))); },
                            handleOpen: handleOpen,
                            handleClose: handleClose,
                        } }) })), _jsx(InformationToggle, __assign({ title: "Why ask my birth year?", chevronColor: theme.palette.primary.main, titleClass: 'text-norc-orange-light md:text-2xl text-base sm:text-base', onClick: function () { return handleSendButtonClick('why_ask_my_age'); } }, { children: _jsx(Typography, __assign({ className: 'text-sm font-light md:text-lg md:font-medium max-w-[890px]' }, { children: "Having this information adds critical context for the accuracy of your hearing screener results, as hearing loss levels vary by age. This hearing screener is only designed for users over the age of 18." })) }))] })) }));
}
